import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import Button from '@/components/common/button/Button';
import styles from './SimulationCompleted.module.css';

const SimulationCompleted: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <CheckCircle className={styles.icon} size={80} />
            <h1 className={styles.title}>¡Simulacro Finalizado!</h1>
            <p className={styles.subtitle}>
                Tus respuestas han sido enviadas. Los resultados se están procesando y estarán disponibles en tu dashboard en breve.
            </p>
            <Button
                variant="primary"
                onClick={() => navigate('/student-dashboard')}
            >
                Ir al Dashboard de Resultados
            </Button>
        </div>
    );
};

export default SimulationCompleted;